import type { NodeTree } from "@craftjs/core";
import type { Action } from "src/types";

import Button from "@/components/editor/primitives/button/button-component";
import { getCurrentSelectionLinks } from "@/components/editor/shared/navigation";

import type { CraftQuery } from "../types";

export function syncNavigationLinks(nodeTrees: NodeTree[], query: CraftQuery) {
  return nodeTrees.map((nodeTree) => {
    const topLevelNode = nodeTree.nodes[nodeTree.rootNodeId];
    if (topLevelNode.displayName === "StandaloneNavigation") {
      const navigationNodes = getCurrentSelectionLinks(nodeTrees).reduce(
        (acc, navLink) => {
          const { rootNodeId, nodes } = query.parseReactElementAsNodeTree(
            <Button
              isLink
              text={navLink.label}
              action={navLink.action as Action}
              noCustomization={true}
            />
          );

          return {
            ...acc,
            [rootNodeId]: {
              ...nodes[rootNodeId],
              parent: topLevelNode.id,
            },
          };
        },
        {}
      );

      return {
        rootNodeId: topLevelNode.id,
        nodes: {
          ...navigationNodes,
          [topLevelNode.id]: {
            ...topLevelNode,
            nodes: Object.keys(navigationNodes),
          },
        },
      };
    }

    return nodeTree;
  });
}
